function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#pathstream-user_svg__clip0_2322_12488)"
}, React.createElement("circle", {
  opacity: 0.5,
  cx: 650,
  cy: 133,
  r: 46,
  fill: "url(#pathstream-user_svg__paint0_linear_2322_12488)"
}), React.createElement("path", {
  d: "M547 3.84v63.32c0 1.57-1.809 2.84-4.04 2.84H397.041c-2.232 0-4.041-1.27-4.041-2.84V3.84c0-1.568 1.809-2.84 4.041-2.84H542.96c2.23 0 4.04 1.272 4.04 2.84z",
  fill: "#A4D8F8"
}), React.createElement("path", {
  d: "M547 3.915V14H393V3.915C393 2.305 394.809 1 397.041 1H542.96c2.23 0 4.04 1.305 4.04 2.915z",
  fill: "#039BE8"
}), React.createElement("path", {
  d: "M540.264 8.23a1.5 1.5 0 10-2.919-.69 1.5 1.5 0 002.919.69zM525.182 9.06a1.5 1.5 0 10-2.12-2.12 1.5 1.5 0 002.12 2.12zM532.264 8.23a1.5 1.5 0 10-2.919-.69 1.5 1.5 0 002.919.69z",
  fill: "#A4D8F8"
}), React.createElement("path", {
  d: "M434.244 54.082c7.224-7.225 7.224-18.939 0-26.164-7.225-7.224-18.938-7.224-26.163 0-7.224 7.225-7.224 18.939 0 26.164 7.225 7.224 18.938 7.224 26.163 0z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M425.605 36a4.5 4.5 0 10-8.885-1.441A4.5 4.5 0 00425.605 36z",
  fill: "#A4D8F8"
}), React.createElement("path", {
  d: "M430 48c-.725-4.54-4.476-8-9-8s-8.275 3.46-9 8h18z",
  fill: "#A4D8F8"
}), React.createElement("path", {
  d: "M539 24h-91v3h91v-3zM539 35h-91v3h91v-3zM462 57h-14v3h14v-3zM479 57h-14v3h14v-3zM538 57h-10v3h10v-3zM525 57h-41v3h41v-3zM477 46h-29v3h29v-3zM517 46h-37v3h37v-3zM537 46h-17v3h17v-3z",
  fill: "#CAECFD"
}), React.createElement("path", {
  d: "M592 85.688V92H491v-6.312c0-1.484 1.187-2.688 2.65-2.688h95.7c1.464 0 2.65 1.204 2.65 2.688z",
  fill: "#4FB9EF"
}), React.createElement("path", {
  d: "M538.5 132c8.008 0 14.5-6.716 14.5-15 0-8.284-6.492-15-14.5-15s-14.5 6.716-14.5 15c0 8.284 6.492 15 14.5 15z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M536.985 108.429l8.338 7.016c.896.754.904 2.168.016 2.932l-8.338 7.181c-1.193 1.028-3.001.149-3.001-1.46v-14.197c0-1.598 1.789-2.48 2.985-1.473v.001z",
  fill: "#4FB9EF"
}), React.createElement("path", {
  d: "M587.111 88.71a1.011 1.011 0 000-1.42.988.988 0 00-1.407 0 1.011 1.011 0 000 1.42.988.988 0 001.407 0zM578.132 87.336a1.003 1.003 0 00-.828-1.149.995.995 0 00-1.145.826c-.088.545.283 1.06.828 1.149a.995.995 0 001.145-.826zM582.173 87.49a1.005 1.005 0 00-.745-1.206.994.994 0 00-1.2.742 1.005 1.005 0 00.745 1.206.995.995 0 001.2-.742z",
  fill: "#039BE8"
}), React.createElement("path", {
  d: "M591.784 85.676v59.649c0 1.36-1.092 2.459-2.434 2.459h-95.7c-1.342 0-2.434-1.099-2.434-2.459v-59.65c0-1.36 1.092-2.46 2.434-2.46h95.7c1.342 0 2.434 1.1 2.434 2.46z",
  stroke: "#3B3B3B",
  strokeWidth: 0.432
}), React.createElement("path", {
  d: "M465.715 217H388c0-5.523 8.931-10 14.311-10h62.735c2.049 0 3.474 2.09 2.773 4.068L465.715 217z",
  fill: "#0171CD"
}), React.createElement("path", {
  d: "M425.271 204L414 221h77.824c2.137-3.874 1.026-10.213-.673-17h-65.88z",
  fill: "#3B3B3B"
}), React.createElement("path", {
  d: "M508.145 217L528 146h-60.58L448 217h60.145z",
  stroke: "#3B3B3B",
  strokeWidth: 0.864,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M520.713 170h-57.746c-3.305 0-5.687-3.149-4.768-6.302l7.32-25.137a4.96 4.96 0 014.768-3.561h57.746c3.305 0 5.687 3.149 4.768 6.302l-7.32 25.137a4.96 4.96 0 01-4.768 3.561z",
  fill: "#0171CD"
}), React.createElement("path", {
  d: "M399.507 124L371 177.359 373.678 201h10.472a15.33 15.33 0 0013.908-8.89L426 131.792l-26.493-7.791V124z",
  fill: "#DE7F4A"
}), React.createElement("path", {
  d: "M377 175l-56 5.818 2.231 18.714L373.575 201 377 175z",
  fill: "#DE7F4A"
}), React.createElement("path", {
  d: "M320.51 181c-4.948.304-34.294 15.424-37.573 16.84-1.192-.048-2.15 1.169-2.482 2.195-1.529 4.708-3.067 9.461-3.429 14.354-.046.621-.066 1.275.25 1.83.316.554 1.082.953 1.722.707.526-.203.772-.734.965-1.217l6.045-14.993c-1.638 4.198-3.113 8.88-3.579 13.307-.06.567-.106 1.159.128 1.69.235.529.836.974 1.465.883.43-.062.771-.348 1.069-.632 4.221-4.029 5.106-9.916 7.435-15.03-1.757 4.111-3.376 8.562-4.158 12.908-.109.607-.207 1.236-.032 1.832.175.595.693 1.153 1.376 1.226.897.098 1.621-.619 2.138-1.283 3.423-4.401 5.344-9.575 7.222-14.668a60.988 60.988 0 00-4.042 13.114c-.178.955-.161 2.205.841 2.572.37.136.794.101 1.176-.006 1.572-.439 2.437-1.91 3.106-3.256a100.067 100.067 0 004.525-10.605c7.616.439 14.938-1.003 21.322-4.748L320.51 181zM441.798 68.089c-.311 2.422-.935 4.817-2.002 7.014-2.666 5.498-7.772 9.213-12.812 12.38-4.968 3.123-9.198 7.906-14.828 9.885-1.947.684-3.614 1.463-5.673 1.615-3.338.247-6.403-2.222-7.887-5.222-2.347-4.743-1.895-10.431-2.198-15.542-.247-4.154-.601-8.522-.252-12.764.078-.964.193-1.922.351-2.87.421-2.476 1.153-4.882 2.369-7.147 1.884-3.514 3.801-5.3 7.511-6.972 3.703-1.669 7.774-2.532 11.838-2.462 6.373.11 12.686 2.517 17.516 6.677 2.619 2.254 4.854 5.1 5.764 8.433.618 2.26.604 4.652.303 6.975z",
  fill: "#DE7F4A"
}), React.createElement("path", {
  d: "M413 94.985L418.657 113 443 105.76c-5.774-5.408-8.227-15.21-10.115-25.76L413 94.985z",
  fill: "#DE7F4A"
}), React.createElement("path", {
  d: "M412 72c.552 0 1-.672 1-1.5s-.448-1.5-1-1.5-1 .672-1 1.5.448 1.5 1 1.5zM398 74c.552 0 1-.672 1-1.5s-.448-1.5-1-1.5-1 .672-1 1.5.448 1.5 1 1.5z",
  fill: "#3B3B3B"
}), React.createElement("path", {
  d: "M405 67l-.15 8.456c-2.768-.453-4.445-.072-.598 4.544",
  stroke: "#3B3B3B",
  strokeWidth: 0.864,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M401.538 86.096c.663 5.007 8.5 3.473 11.462-4.093-8.113-.057-13.825.681-11.462 4.093z",
  fill: "#C6642D"
}), React.createElement("path", {
  d: "M402 86.264c2.48 2.124 6.607-.674 11-4.264-4.713 1.602-8.884 3.111-11 4.264z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M411.343 187c3.156-6.697 4.198-14.158 6.199-21.284 1.757-6.263 4.265-12.29 6.264-18.48 2-6.191 2.816-12.65 3.153-19.146.07-1.343.05-2.692-.054-4.028-.708-9.085-8.805-15.794-17.895-14.998l-1.66.146c-5.13.68-9.494 4.287-12.349 8.597-2.856 4.31-4.44 9.313-6.057 14.222-1.618 4.909-3.35 9.885-6.437 14.032-1.562 2.098-3.44 3.941-5.069 5.987-4.694 5.893-7.139 13.214-9.438 20.386L411.343 187z",
  fill: "#039BE8"
}), React.createElement("path", {
  d: "M420 68l-.245 3.469c-.158 2.262-1.698 4.2-3.895 4.93a16 16 0 01-1.717.472c-3.458.739-6.749-1.795-6.898-5.251L407 68.884 419.999 68H420z",
  stroke: "#3B3B3B",
  strokeWidth: 0.864,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M420 66l-.126 1.98L406.15 69l-.15-1.841L420 66zM403 68l-.114 1.379-10.855.621-.031-1.321L403 68z",
  stroke: "#3B3B3B",
  strokeWidth: 0.864,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M420 66l-.126 1.98L406.15 69l-.15-1.841L420 66zM403 68l-.114 1.379-10.855.621-.031-1.321L403 68z",
  fill: "#3B3B3B"
}), React.createElement("path", {
  d: "M402 69.001l-.25 3.931c-.154 2.44-1.372 4.557-3.083 5.376-.459.218-.904.4-1.338.535-2.687.846-5.198-1.837-5.265-5.562l-.064-3.53L402 69v.001zM403 72.41l4-.41M420 70.382l4-.382M393 73l3-1",
  stroke: "#3B3B3B",
  strokeWidth: 0.864,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M408.619 64.295c.516-.005 1.018-.145 1.524-.243 1.726-.33 3.535-.162 5.194.414.685.239 1.37.55 2.094.533.725-.016 1.509-.493 1.566-1.216.035-.446-.218-.878-.563-1.164-.345-.287-.772-.452-1.196-.598-2.2-.763-4.543-1.17-6.863-.97-.88.075-2.565.424-3.112 1.234-.715 1.057.124 2.024 1.357 2.01h-.001zM402.998 65.776c-.058.726-.868 1.207-1.618 1.224-.747.015-1.456-.297-2.165-.537a10.948 10.948 0 00-3.402-.584c-1.321-1.117-.911-2.047.362-2.879 1.703.094 3.39.457 5.004 1.001.438.149.88.315 1.236.603.357.288.618.722.582 1.172h.001z",
  fill: "#3B3B3B"
}), React.createElement("path", {
  d: "M442.149 77.827c-.988.875-1.368 2.266-1.437 3.59-.071 1.324.119 2.652.037 3.975-.208 3.373-1.9 8.406-5.126 7.5-2.257-.633-3.835-2.77-4.554-5.021-.72-2.25-.747-4.656-.954-7.012-.208-2.356-.442-4.775-1.82-6.688a16.994 16.994 0 01-4.912-3.078c-.423-.38-.838-.797-1.058-1.323-.269-.645-.215-1.373-.18-2.073a28.752 28.752 0 00-.224-5.222c-.096-.706-.224-1.427-.592-2.035-.456-.75-1.225-1.242-1.976-1.69-1.889-1.122-3.87-2.15-5.446-3.688-1.577-1.538-2.748-3.601-2.439-5.792l-3.974 5.912c-.71 1.056-1.427 2.12-2.324 3.02-1.84 1.846-4.426 2.913-7.02 2.895-.556-.003-1.168-.081-1.544-.495-.487-.122-.522-.332-.57-.836-.289-3.013 1.21-5.945 3.184-8.225 2.777-3.209 6.966-5.572 11.123-4.828 1.522-2.816 3.932-5.33 6.816-6.68 2.884-1.35 6.416-1.45 9.181.133 3.377 1.933 5.308 6.052 8.971 7.35 1.188.42 2.472.503 3.67.896 1.663.549 3.072 1.668 4.429 2.783 2.088 1.717 4.199 3.548 5.391 5.985.906 1.853 1.221 3.957 1.198 6.024-.064 5.775-3.548 10.812-7.849 14.621l-.001.002z",
  fill: "#3B3B3B"
}), React.createElement("path", {
  d: "M491.998 202.999h-66.624l-2.888-11.99s-7.311-16.09-7.818-16.045c-14.278-1.183-9.857-19.084-4.93-33.777l.086-32.553 4.255-.969c.025 2.241-.145 4.491-.091 6.733.07 3.06.607 6.24 2.425 8.709 2.548 3.46 7.261 4.873 11.537 4.33 4.279-.545 8.168-2.774 11.56-5.422 5.722-4.468 10.293-10.158 14.602-16.015l14.476.863c8.519 10.143 15.049 32.304 19.503 67.005L492 203l-.002-.001z",
  fill: "#039BE8"
}), React.createElement("path", {
  d: "M422 191s-7.108-16.114-7.601-16.069c-13.88-1.184-9.583-19.113-4.792-33.829L409.69 117",
  stroke: "#3B3B3B",
  strokeWidth: 0.864,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M454 106.539c-4.294 5.833-8.85 11.499-14.553 15.949-3.38 2.638-7.256 4.856-11.521 5.399-4.262.542-8.959-.866-11.499-4.312-1.811-2.458-2.346-5.627-2.416-8.673-.054-2.233.116-4.473.091-6.704L428.155 105l25.844 1.538.001.001zM479 131.79l-22.904 49.446-3.088 6.665-1.949 4.208a15.333 15.333 0 01-13.91 8.891h-10.471L424 177.359l.79-1.478L452.506 124l26.493 7.791.001-.001z",
  fill: "#DE7F4A"
}), React.createElement("path", {
  d: "M431 175l-56 5.818 2.231 18.714L427.575 201 431 175z",
  fill: "#DE7F4A"
}), React.createElement("path", {
  d: "M374.51 181c-4.948.304-34.294 15.424-37.572 16.84-1.193-.048-2.151 1.169-2.483 2.195-1.529 4.708-3.067 9.461-3.429 14.354-.046.621-.066 1.275.25 1.83.316.554 1.082.953 1.722.707.526-.203.772-.734.965-1.217l6.045-14.993c-1.638 4.198-3.113 8.88-3.579 13.307-.06.567-.106 1.159.128 1.69.235.529.836.974 1.465.883.43-.062.771-.348 1.069-.632 4.221-4.029 5.106-9.916 7.435-15.03-1.757 4.111-3.376 8.562-4.158 12.908-.109.607-.207 1.236-.032 1.832.175.595.693 1.153 1.376 1.226.897.098 1.622-.619 2.138-1.283 3.423-4.401 5.344-9.575 7.222-14.668a60.988 60.988 0 00-4.042 13.114c-.178.955-.161 2.205.841 2.572.37.136.794.101 1.176-.006 1.572-.439 2.437-1.91 3.106-3.256a100.067 100.067 0 004.525-10.605c7.616.439 14.938-1.003 21.322-4.748L374.51 181z",
  fill: "#DE7F4A"
}), React.createElement("path", {
  d: "M387 180l-13.129 1.369c-4.856.3-33.654 15.232-36.871 16.631",
  stroke: "#3B3B3B",
  strokeWidth: 0.864,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M514 217H261v4h253v-4z",
  fill: "#039BE8"
}), React.createElement("path", {
  d: "M370 213h-4v1h4v-1zM377 213h-4v1h4v-1zM384 213h-4v1h4v-1zM391 213h-4v1h4v-1zM398 213h-4v1h4v-1zM405 213h-4v1h4v-1zM412 213h-4v1h4v-1z",
  fill: "#3B3B3B"
}), React.createElement("path", {
  d: "M372 214h-97.941l-13.002-68.223c-.373-1.961 1.126-3.777 3.116-3.777h91.482a3.174 3.174 0 013.116 2.584L372 214zM274 214v3h139v-3H274z",
  fill: "#EBF8FF"
}), React.createElement("path", {
  d: "M274 214.252l98-.252v3",
  stroke: "#3B3B3B",
  strokeWidth: 0.864,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M507.715 217H430c0-5.523 8.931-10 14.311-10h62.735c2.049 0 3.474 2.09 2.773 4.068L507.715 217z",
  fill: "#0171CD"
}), React.createElement("path", {
  d: "M467.343 185c3.156-6.697 4.198-14.158 6.199-21.284 1.757-6.263 4.265-12.29 6.264-18.48 2-6.191 2.816-12.651 3.153-19.146.07-1.343.05-2.692-.054-4.028-.708-9.085-8.805-15.794-17.895-14.998l-1.66.146c-5.13.68-9.494 4.287-12.349 8.597-2.856 4.31-4.44 9.313-6.057 14.222-1.618 4.909-3.35 9.885-6.437 14.032-1.562 2.098-3.44 3.941-5.069 5.987-4.694 5.893-7.139 13.214-9.438 20.386L467.343 185z",
  fill: "#039BE8"
}), React.createElement("path", {
  d: "M445 130c-1.622 4.878-3.358 9.822-6.454 13.942-1.566 2.085-3.449 3.916-5.083 5.948-4.706 5.856-7.158 13.13-9.463 20.256l2.564.854",
  stroke: "#3B3B3B",
  strokeWidth: 0.864,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M439.092 79.364a9 9 0 10-12.728-12.728 9 9 0 000 12.728 9 9 0 0012.728 0z",
  fill: "#DE7F4A"
}), React.createElement("path", {
  d: "M426 73c0-3.314 2.911-6 6.5-6s6.5 2.687 6.5 6M430.657 67c.886 5.048.074 8.773-2.657 11",
  stroke: "#3B3B3B",
  strokeWidth: 0.864,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M442.125 75.298c-1.163 2.704-1.344 5.997-.882 8.792.488 2.957 1.298 5.945.842 8.908-.229 1.484-.77 2.908-.985 4.394-.412 2.854.463 5.866 2.342 8.065 1.746 2.043 4.292 3.402 5.649 5.718 2.744 4.685-.443 11.228 2.448 15.825h15.85v-10.719L469.425 127H486.9c.38-2.861-.355-5.753-1.66-8.332-.972-1.921-2.367-3.617-3.243-5.583-2.191-4.915-.992-11.14-4.315-15.385-2.873-3.671-8.204-4.584-11.433-7.95-2.968-3.094-3.633-7.645-5.417-11.531-1.186-2.583-2.951-4.964-5.348-6.511-2.398-1.548-5.472-2.183-8.196-1.32-2.538.805-4.192 2.652-5.163 4.91z",
  fill: "#3B3B3B"
}), React.createElement("path", {
  d: "M425 176l5-1",
  stroke: "#3B3B3B",
  strokeWidth: 0.864,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M221.588 151h117.824c3.084 0 5.588 2.527 5.588 5.638v27.724c0 3.112-2.505 5.638-5.588 5.638H221.588c-3.084 0-5.588-2.527-5.588-5.638v-27.724c0-3.112 2.505-5.638 5.588-5.638z",
  fill: "#A4D8F8"
}), React.createElement("path", {
  d: "M233 182c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
  fill: "#4FB9EF"
}), React.createElement("path", {
  d: "M233.721 164h-.442c-1.259 0-2.279.873-2.279 1.951v4.098c0 1.078 1.02 1.951 2.279 1.951h.442c1.259 0 2.279-.873 2.279-1.951v-4.098c0-1.078-1.02-1.951-2.279-1.951zM234 174h-1v4h1v-4z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M236.583 169v1.723c0 1.573-1.252 2.851-2.791 2.851h-.583c-1.539 0-2.791-1.278-2.791-2.851V169H230v1.723c0 1.807 1.439 3.277 3.208 3.277h.583c1.769 0 3.209-1.47 3.209-3.277V169h-.418.001zM235 177h-3v1.001h3V177zM251 162h-2v18h2v-18zM256 165h-2v15h2v-15zM271 165h-2v15h2v-15zM316 165h-2v15h2v-15zM281 169h-2v11h2v-11zM286 171h-2v10h2v-10zM311 171h-2v10h2v-10zM326 171h-2v10h2v-10zM276 162h-2v18h2v-18zM291 162h-2v18h2v-18zM306 162h-2v18h2v-18zM331 162h-2v18h2v-18zM301 159h-2v21h2v-21zM336 159h-2v21h2v-21zM296 162h-2v18h2v-18zM261 169h-2v11h2v-11zM266 174h-2v6h2v-6zM321 174h-2v6h2v-6z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M374.46 46H266.54c-1.955 0-3.54 1.596-3.54 3.566v69.868c0 1.97 1.585 3.566 3.54 3.566h107.92c1.955 0 3.54-1.596 3.54-3.566V49.566c0-1.97-1.585-3.566-3.54-3.566z",
  fill: "url(#pathstream-user_svg__paint1_linear_2322_12488)"
}), React.createElement("path", {
  d: "M272.001 109H371l-17.67-29.466c-2.378-3.965-7.326-4.64-10.477-1.427L323.48 97.86l-26.15-30.46c-3.521-4.103-9.633-2.749-11.509 2.55L272 109h.001z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M327.596 76.3a6 6 0 10-2.757-11.678 6 6 0 002.757 11.679z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M582 141.435V192h-45v-58h37.812l7.188 7.435z",
  fill: "#A4D8F8"
}), React.createElement("path", {
  d: "M575 134v7h7l-7-7z",
  fill: "#039BE8"
}), React.createElement("path", {
  d: "M570 140h-22v2h22v-2zM578 146h-37v2h37v-2zM578 153h-37v2h37v-2zM578 160h-37v2h37v-2zM578 167h-37v2h37v-2zM578 174h-37v2h37v-2zM578 182h-14v2h14v-2z",
  fill: "#4FB9EF"
}), React.createElement("path", {
  d: "M414 96.615L424 90l-8.481 12L414 96.615zM456 181.034L453.034 188 445 177l11 4.034z",
  fill: "#C6642D"
}), React.createElement("path", {
  d: "M479 148c-1.8 5.26-3.839 10.441-5.333 15.798-1.979 7.098-3.011 14.531-6.136 21.202L456 181.1M273 35h-34v26h34V35z",
  stroke: "#3B3B3B",
  strokeWidth: 0.864,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M239 35l17 13 17-13",
  stroke: "#3B3B3B",
  strokeWidth: 0.864,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "pathstream-user_svg__paint0_linear_2322_12488",
  x1: 614.851,
  y1: 95.02,
  x2: 669.815,
  y2: 174.99,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A4D8F8"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#A4D8F8",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "pathstream-user_svg__paint1_linear_2322_12488",
  x1: 320.5,
  y1: 122.934,
  x2: 320.5,
  y2: 37.172,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A4D8F8"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#81CDF4"
})), React.createElement("clipPath", {
  id: "pathstream-user_svg__clip0_2322_12488"
}, React.createElement("path", {
  d: "M0 0h636v210c0 6.627-5.373 12-12 12H0V0z",
  fill: "#fff"
})));

var SvgPathstreamUser = function SvgPathstreamUser(props) {
  return React.createElement("svg", _extends({
    width: 636,
    height: 222,
    viewBox: "0 0 636 222",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "7403aa0d9b08ec2297c4a0cf7cfe72ad.svg";
export { SvgPathstreamUser as ReactComponent };